import { fraction } from '@lib/format';
import { Colors } from '@src/colors';
import { FunctionComponent, useEffect, useState } from 'react';
import { LabelAbove } from './label-above';
import './number-input.scss';
import { WireIcon } from './wire-icon';

export const NumberInput: FunctionComponent<{
    disabled?: boolean;
    label: string;
    value: number;
    step?: number;
    min?: number;
    max?: number;
    onChange: (value: number) => void;
}> = ({ label, disabled = false, value: initialValue, step = 1, min = 0, max = 99, onChange }) => {
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        onChange(value);
    }, [value]);

    const decrement = () => {
        if (value <= min) return;
        setValue(Math.max(value - step, min));
    };

    const increment = () => {
        if (value >= max) return;
        setValue(Math.min(value + step, max));
    };

    return (
        <LabelAbove className="estimator-number-input" label={label}>
            <main className={`estimator-input${disabled ? ' disabled' : ''}`}>
                <WireIcon
                    dataCy={`${label.toLowerCase()}-decrement`}
                    onClick={disabled ? undefined : decrement}
                    colorName={disabled ? Colors.duskLightest : undefined}
                    tabIndex={0}
                    svg="minus"
                    className="btn btn-v-utility"
                />
                <span>{fraction(value)}</span>
                <WireIcon
                    dataCy={`${label.toLowerCase()}-increment`}
                    onClick={disabled ? undefined : increment}
                    colorName={disabled ? Colors.duskLightest : undefined}
                    tabIndex={0}
                    svg="plus"
                    className="btn btn-v-utility"
                />
            </main>
        </LabelAbove>
    );
};
